module.exports = __webpack_public_path__ + "static/media/multimedia.7011c36b.png";